import { useEffect, useState } from "react";
import { AuthProvider } from "src/contexts/AuthContext/AuthContext";
import WebViewMessageEventEmitter from "src/WebViewEventEmitter";
import AppTemplate from "../containers/AppTemplate/AppTemplate";
import LinkPickerSandbox from "src/components/LinkPicker/LinkPickerSandbox";

const App = () => {
	const [accessToken, setAccessToken] = useState(false);

	useEffect(() => {
		document.title = "Mee Admin";
	}, []);

	useEffect(() => {
		window.authTokens = { accessToken: null, refreshToken: null };

		if (!window.ReactNativeWebView) return;

		WebViewMessageEventEmitter.addListener(
			"AUTH_TOKENS_RESPONSE",
			(authTokens) => {
				window.authTokens = authTokens;
				setAccessToken(Boolean(authTokens));
			}
		);

		WebViewMessageEventEmitter.emit("GET_AUTH_TOKENS");

		return () => {
			WebViewMessageEventEmitter.removeEventListener("AUTH_TOKENS_RESPONSE");
		};
	}, []);

	const isWebview = Boolean(window.ReactNativeWebView);

	// Sandbox routes bypass MSAL — for UI iteration only. Dev builds only;
	// import.meta.env.DEV is statically false in production builds, so the
	// bundle drops the LinkPickerSandbox import via tree-shaking and the path
	// becomes unreachable in prod.
	if (
		import.meta.env.DEV &&
		window.location.pathname.startsWith("/_sandbox/link-picker")
	) {
		return <LinkPickerSandbox />;
	}

	if (accessToken && isWebview) {
		return <AppTemplate />;
	}

	return (
		<AuthProvider>
			<AppTemplate />
		</AuthProvider>
	);
};

export default App;
